import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { first, flatMap } from 'rxjs';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import * as $ from 'jquery';
import { TimeScale } from 'chart.js';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-mentorlist',
  templateUrl: './mentorlist.component.html',
  styleUrls: ['./mentorlist.component.scss']
})
export class MentorlistComponent implements OnInit {
  imageshow:boolean;
  imageSrc: string | ArrayBuffer | null = null;
    

  district_list: any[] = this.ApiService.all_districts;
  users: any = JSON.parse(localStorage.getItem('login_user_details'));
  zones: any = this.ApiService.all_districts_zone;
  user_name: any = this.ApiService.user_details.firstname;
  user_id: any = this.ApiService.user_details.id;  
  coursedatas: any = [];
  spinner: boolean;
  tableshow: boolean=false;
  userIdlogin: any;
  mentorcourse!: FormGroup;
  mentorcourse_motivational!: FormGroup;
  user_activity_id: any;
  district: any = this.ApiService.district;
  constituency: any = this.ApiService.constituency;
  user_district: any = this.ApiService.user_details.district;
  user_constituency: any = this.ApiService.user_details.constituency;
  
  count_activity: any;
  courses_assigned_to: any;

  
  userDistrict: any = this.ApiService.user_details.district;
  userConstituency: any = this.ApiService.user_details.constituency;
  userId: any = this.ApiService.user_details.id;

  districtname: any;
  isEditModetech: boolean = false;
  isEditModeMove: boolean = false;
  courseID: any;
  show: boolean = false;



  constructor(private fb: FormBuilder, private ApiService: ApiServiceService, private router: Router,
    private spinnerService: NgxSpinnerService, public datepipe:DatePipe, private elementRef: ElementRef, private renderer: Renderer2) {
      this.mentorcourse = this.fb.group({
   
        course_name: ['',Validators.required],
        typeofcourse: ['Technical'],
        course_topic: ['',Validators.required],
        user_id: this.users.id,
        course_des: [''],
        course_date: ['',Validators.required],
        course_time: ['',Validators.required],
        session_link: ['',Validators.required],
        comments: [''],
        image:['',[this.imageSizeValidator(60000)]],
        mode: ['Online', Validators.required],
       
      });
      this.mentorcourse_motivational = this.fb.group({
     
        course_name: ['',Validators.required],
        course_topic: [''],
        typeofcourse: ['Career Guidance'],
        user_id: this.users.id,
        course_des: [''],
        course_date: ['',Validators.required],
        course_time: ['',Validators.required],
        session_link: ['',Validators.required],
        image:['',[this.imageSizeValidator(60000)]],
        comments: [''],
        mode: ['Online', Validators.required],
        
      });
      console.log('mentorcourse_motivational', this.mentorcourse_motivational);
      console.log('mentorcourse_motivational', this.mentorcourse);

  }
  dtOptions: DataTables.Settings = {};


  

  ngOnInit(): void{
    this.handleBackButtonForModal();

    console.log(this.users,this.users.firstname, "sndknsdkjn");
   this.userIdlogin=this.users.id
   
    this.coursedatas=[];
    this.showSpinner();
    this.ApiService.get_courese_byuserId(this.userIdlogin).subscribe((data: any) => {
      this.coursedatas= data.course;
      
      this.tableshow=true;
      console.log('coursedata',data);
      this.spinnerService.hide();
    });
    

   
    this.dtOptions = {
      pagingType: 'full_numbers'
    };

   

  }

  uploadFiles: any = '';

  selectFiles(event: any) {
    if (event.target.files[0].size < 60000) {
      const formData: FormData = new FormData();
      formData.append('file', event.target.files[0]);
      this.ApiService.uploadActivityFile(formData).subscribe((da: any) => {
        this.uploadFiles = da;
      });
    } else {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "The size should be less than 60kb",
        showConfirmButton: false,
        timer: 1500
      });
      $('#file').val('');
      
      // Mark the 'image' form control as invalid
      this.mentorcourse.get('image')?.setErrors({ 'imageSizeExceeded': true });
    }
  }
  imageSizeValidator(maxSize: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (control.value && control.value.size) {
        const fileSize = control.value.size; // Get the size of the file
        if (fileSize > maxSize) {
          return { 'imageSizeExceeded': true }; // Return an error if the size exceeds the limit
        }
      }
      return null; // Return null if the size is within the limit
    };
  }
  //Default date time in form
  
  public showSpinner(): void {
    this.spinnerService.show();
    }

  
    current_date: any;
    current_time: any;
    getCurrentDates(): string {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()+1).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
  
    // Function to get the current time in the format HH:MM
    getCurrentTime(): string {
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      return `${hours}:${minutes}`;
    }
    setCurrentdate() {
      this.current_date = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
      this.current_time = this.datepipe.transform(new Date(), 'HH:mm');
      this.mentorcourse.get('district').setValue(this.userDistrict);
      this.mentorcourse.get('constituency').setValue(this.userConstituency);
      this.mentorcourse.get('user_id').setValue(this.userId);
    }
  
  
  
    postdata(data:any)
    {
      console.log(data.value);
      data.value['image'] = this.uploadFiles ? this.uploadFiles : 'images/course.jpg';
      data.value['user_id'] = this.users.id;
      data.value['typeofcourse'] = 'Technical';

      this.ApiService.createMentorcourse(data.value).pipe().subscribe(
        data => {
          console.log(data);
          // this.spinnerService.hide();
        
          setTimeout(function () {
            Swal.fire({
              title: "Course has been created Successfully!",
              icon: "success",
              confirmButtonText: "Okay",
              confirmButtonColor:'#015792',
              iconColor: "#015792" // Set the icon color here
            }).then(() => {
              window.location.reload();
              this.mentorcourse.reset();
            });
          }, 100);
        },
        
          
          error => {
            console.log(error);
          });
    }
  
    postdata_motivation(motivationaldata:any){
      console.log(motivationaldata.value);
      motivationaldata.value['image'] = this.uploadFiles ? this.uploadFiles : 'images/course.jpg';
      motivationaldata.value['user_id'] = this.users.id;
      motivationaldata.value['typeofcourse'] = 'Career Guidance';
      this.ApiService.createMentorcourse(motivationaldata.value).pipe().subscribe(
        data => {
          console.log(data);
          this.spinnerService.hide();
        
          setTimeout(function () {
            Swal.fire({
              title: "Career guidance has been created Successfully!",
              icon: "success",
              confirmButtonText: "Okay",
              confirmButtonColor:'#015792',
              iconColor: "#015792" // Set the icon color here
            }).then(() => {
              window.location.reload();
              this.mentorcourse.reset();
            });
          }, 100);
        },
        
          
          error => {
            console.log(error);
          });
    }
    Formreset() {
      this.mentorcourse.reset();
      this.mentorcourse_motivational.reset();
      this.isEditModeMove = false;
      this.isEditModetech = false;
     
    }
    create(){
      this.isEditModetech = false;
      this.isEditModeMove = false;
      this.mentorcourse_motivational.enable();
      this.mentorcourse.enable();
      this.show = false;
      this.imageshow=false;
    }

    get_coursebyid(course_id,editshow:any){  
          
      console.log(editshow);
      this.courseID=course_id;
      this.ApiService.get_coursebyid(course_id).subscribe((data: any) => {     
        if(data.course.typeofcourse =='Technical'){
          this.isEditModetech = true;
          // this.isEditModeMove = false;
        this.mentorcourse.patchValue(data.course);
        this.mentorcourse.patchValue({  
            
          session_link: data.course.online_meet_link,
          comments: data.course.comment,
          id:data.course.id,

        });
        // this.mentorcourse.get('session_link').setValue(data.course.online_meet_link);
        // this.mentorcourse.get('comments ').setValue(data.course.comment);
        // this.mentorcourse.get('id').setValue(data.course.id);

        this.courseID=data.course.id;
      }
      else{
        this.isEditModeMove = true;
        // this.isEditModetech = false;
        
        this.mentorcourse_motivational.patchValue(data.course);
        this.mentorcourse_motivational.patchValue({    
          session_link: data.course.online_meet_link,
          comments: data.course.comment,
          id:data.course.id
        });
        // this.mentorcourse_motivational.get('session_link').setValue(data.course.online_meet_link);
        // this.mentorcourse_motivational.get('comments ').setValue(data.course.comment);
        // this.mentorcourse_motivational.get('id').setValue(data.course.id);

        this.courseID=data.course.id;
        console.log('mentorcourse', this.mentorcourse);
        console.log('mentorcourse', this.mentorcourse_motivational);
      }
      if(editshow =='SHOW'){
        this.mentorcourse_motivational.disable();
        this.mentorcourse.disable();
        this.show = true;
        this.imageshow = true;
        this.imageSrc = `https://myroots.redmindtechnologies.com/api/${data.course.images}`;
     

        // this.isEditModeMove =false;
        // this.isEditModetech = false;

      }
    else{     
      this.mentorcourse_motivational.enable();
      this.mentorcourse.enable();
      this.show = false;
      this.imageshow = false;
   


    }
      
       
      });

    }

    posteditData(data:any){
      console.log(this.isEditModetech )
      console.log(data.value);
      console.log(this.courseID )
      data.value.courseID = this.courseID;
      data.value['image'] = this.uploadFiles ? this.uploadFiles : 'images/course.jpg';
      data.value['user_id'] = this.users.id;

      this.ApiService.updateMentorcourse(data.value).pipe().subscribe(
        data => {
          console.log(data);
          // this.spinnerService.hide();
        
          setTimeout(function () {
            Swal.fire({
              title: "Course has been Updated Successfully!",
              icon: "success",
              confirmButtonText: "Okay",
              confirmButtonColor:'#015792',
              iconColor: "#015792" // Set the icon color here
            }).then(() => {
              window.location.reload();
              this.mentorcourse.reset();
            });
          }, 100);
        },
        
          
          error => {
            console.log(error);
          });
    }

    handleBackButtonForModal() {
      // Push initial state to history
      history.pushState(null, '', window.location.href);
    
      window.onpopstate = () => {
        const modal = document.querySelector('.modal.show') as HTMLElement;
        if (modal) {
          // Find the close button inside the modal and trigger a click event on it
          const closeButton = modal.querySelector('.close') as HTMLElement;
          if (closeButton) {
            closeButton.click();
          }
    
          // Prevent default back navigation
          history.pushState(null, '', window.location.href);
        } else {
          // Allow back navigation as usual if modal is not open
          this.router.navigate(['previous-page']); // Replace 'previous-page' with the actual route you want to navigate to
        }
      };
    }
    ngOnDestroy(): void {
      // Cleanup event listener to avoid memory leaks
      window.onpopstate = null;
    }
}





